import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FinanceCalc } from '@perxis-auto/ui-kit/lib/components/FinanceCalc';
import { Icon } from '@perxis-auto/ui-kit/lib/components/Icon';

import { useAppSelector } from '@/features/hooks';
import { rootSelectors } from '@/features/store';

import { TradeInCardProps } from './TradeInCard.types';

import styles from './TradeInCard.module.scss';

function TradeInCard({ onClick, priceLabel }: TradeInCardProps) {
  const { t } = useTranslation();

  const tradeIn = useAppSelector(rootSelectors.tradeIn.tradeInSelector);

  const priceValue = useMemo(() => {
    return Number(tradeIn?.min || tradeIn?.avg || tradeIn?.max || 0);
  }, [tradeIn]);

  return (
    <FinanceCalc
      title={t('tradeInCard.title')}
      icon={
        <Icon name="service-trade-in" sticker="car-card-trade-in-calc-icon" size={20} />
      }
      buttonIcon={
        <Icon name="forward" size={18} sticker="car-card-trade-in-forward-icon" />
      }
      priceLabel={priceLabel || t('tradeInCard.priceLabel')}
      priceValue={t('currency', { value: priceValue })}
      buttonLabel={t('tradeInCard.estimate')}
      onButtonClick={onClick}
      className={styles.tradeInCard}
    />
  );
}

export default TradeInCard;
